<script src="https://cdn.tailwindcss.com"></script>
<template>
  <div class="content">
    <v-card>
      <v-tabs v-model="currentTabIndex" background-color="#e2007a" dark>
        <v-tab v-for="tab in tabs" :key="tab" :value="tab">{{ tab }}</v-tab>
      </v-tabs>
    </v-card>

    <Segur v-if="currentTabIndex === 0"></Segur>
    <SegurBon v-if="currentTabIndex === 1"></SegurBon>
    <Segurasp v-if="currentTabIndex === 2"></Segurasp>
    <SegurStats v-if="currentTabIndex === 3"></SegurStats>
    <SegurDoc v-if="!isProkov && currentTabIndex === 4"></SegurDoc>
    <SegurArchives v-if="isProkov && currentTabIndex === 4"></SegurArchives>
  </div>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import store from "@/store";
import SegurBon from "./Segurbon.vue";
import Segur from "./Segur.vue";
import Segurasp from "./Segurasp.vue";
import SegurStats from "./SegurStats.vue";
import SegurDoc from "./SegurDoc.vue";
import SegurArchives from "./SegurArchives.vue";

export default {
  name: "Segurmain",
  components: {
    SegurBon,
    Segur,
    Segurasp,
    SegurStats,
    SegurDoc,
    SegurArchives,
  },
  data: function () {
    const pc = localStorage.getItem("partnerCode");
    const isProkov = !pc || pc === "prokov";
    const tabs = ["Segur Liste", "Segur Création", "Segur ASP", "Statistiques"];
    if (!isProkov) tabs.push("Documentation");
    if (isProkov) tabs.push("Archives V1");
    return {
      currentTabIndex: 0,
      isProkov,
      tabs,
    };
  },
  created: function () {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
